// test412
(412 && 0);
